import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";

const ToggleToEdit = forwardRef((props, ref) => {
    const { renderNotToggled, onToggleOpen, children } = props;
    const [isEditMode, setEditMode] = useState(false);

    function toggleOpen() {
        setEditMode(true);
    }

    // Use ref to call toggleClose() from parent component
    useImperativeHandle(ref, () => ({
        toggleClose() {
            setEditMode(false);
        },
    }));

    useEffect(() => {
        if (isEditMode && onToggleOpen)
            onToggleOpen();
    }, [isEditMode, onToggleOpen]);

    if (!isEditMode)
        return renderNotToggled(toggleOpen);

    return React.Children.map(children, child => {
        // Checking isValidElement is the safe way and avoids a typescript error too.
        if (React.isValidElement(child))
            return React.cloneElement(child, { className: `${child.props.className} toggle-to-reveal`});

        return child;
    });
});

export default ToggleToEdit;
